import { createSelector } from 'reselect';

import { getWindowHeight, getWindowWidth } from './breakpoint';
import { getSewpatFigurineOverlayDimension } from './sewpats';

export default (state, action, breakpoint) => {
    switch (action.type) {
        default:
            return state;
    }
};

export const getSewpatStripeCountToRender = createSelector(
    [getWindowWidth, getWindowHeight, getSewpatFigurineOverlayDimension],
    (windowWidth, windowHeight, figurineDimension) => {
        if (!windowWidth || !figurineDimension.width) {
            return 1;
        }
        const { width, height } = figurineDimension;
        const maxHeight = windowHeight * 0.8;
        const calcHeight = Math.min(height, maxHeight);
        const figRatio = (
            width / height
        );
        const calcWidth = calcHeight * figRatio;
        var columnCount;
        columnCount = Math.max(Math.floor(windowWidth / (calcWidth * 2)), 1);
        return columnCount;
    },
);




// WEBPACK FOOTER //
// ./src/reducers/ui.sewpatgalleries.js